"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _SiteOrderingSearchCondition = _interopRequireDefault(require("./components/SiteOrderingSearchCondition"));
var _SiteOrderingSearchResult = _interopRequireDefault(require("./components/SiteOrderingSearchResult"));
var _siteOrderingActions = require("./siteOrderingActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 拠点表示順設定
 */
class SiteOrderingMain extends _react.default.Component {
  constructor() {
    super(...arguments);
    // 詳細ボタン押下ハンドラ
    _defineProperty(this, "onDetailClick", (kaishaCd, areaCd) => {
      return () => {
        this.props.goDetail(kaishaCd, areaCd);
      };
    });
    // 更新アイコン押下ハンドラ
    _defineProperty(this, "onUpdateClick", (kaishaCd, areaCd) => {
      return () => {
        this.props.sendTarget(kaishaCd, areaCd);
      };
    });
    /**
     * 並び変え更新後の処理
     */
    _defineProperty(this, "onSortUpdate", returnList => {
      const sendList = returnList.map(e => {
        return {
          siteNo: e.key,
          sortOrder: e.sortOrder
        };
      });
      this.handleRegister(sendList);
    });
    // 並び順の更新処理
    _defineProperty(this, "handleRegister", sendList => {
      const {
        callAPI,
        openInfoBar,
        setIsReSearch,
        targetKaishaCd,
        targetAreaCd
      } = this.props;
      const sendData = {
        siteSortOrders: sendList,
        kaishaCd: targetKaishaCd,
        areaCd: targetAreaCd
      };
      let url = _APIs.SITE_ORDERING_REGISTER;
      callAPI(url, sendData).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, response.message);
          setIsReSearch(true); // 再検索を行うために、isReSearchをtrueに変更する
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    });
  }
  componentDidMount() {
    const {
      scrollY,
      noSticky
    } = this.props.scrollTop;
    if (noSticky) {
      _windowUtil.default.windowScroll(scrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const {
      intl,
      pms,
      isNewWindow
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.MASTERDATA_SITE_ORDERING_TITLE
      })
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SiteOrderingSearchCondition.default, {
      pms: pms,
      isNewWindow: isNewWindow
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SiteOrderingSearchResult.default, {
      onDetailClick: this.onDetailClick,
      onUpdateClick: this.onUpdateClick,
      onSortUpdate: this.onSortUpdate
    })))));
  }
}
const mapStateToProps = state => {
  return {
    searchConditions: state.siteOrdering.searchConditions,
    paging: state.siteOrdering.paging,
    scrollTop: state.siteOrdering.scrollTop,
    targetKaishaCd: state.siteOrdering.targetKaishaCd,
    targetAreaCd: state.siteOrdering.targetAreaCd
  };
};
const mapDispatchToProps = dispatch => {
  return {
    goDetail: (kaishaCd, areaCd) => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.GO_DETAIL](kaishaCd, areaCd)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    setIsReSearch: isReSearch => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.SET_IS_RE_SEARCH](isReSearch)),
    sendTarget: (kaishaCd, areaCd) => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.SEND_TARGET](kaishaCd, areaCd))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(SiteOrderingMain)));